import React from 'react';
import T from 'i18n-react';
import clsx from 'clsx';
import PubSub from 'pubsub-js';

import {
    AppBar,
    IconButton,
    Menu,
    MenuItem,
    Toolbar,
    Typography,
    withStyles,
} from '@material-ui/core/';

import AIAgent from '@apricityhealth/web-common-lib/components/AIAgent';
import AccountCircle from '@material-ui/icons/AccountCircle';
import MenuIcon from '@material-ui/icons/Menu';
import SelectPlan from '@apricityhealth/web-common-lib/components/SelectPlan';

class AppHeader extends React.Component {
    constructor(props) {
        super(props);
        // The plan selector is the expert's working context, so the chat panel has to see it — §10.11 of
        // docs/plans/mcp-server.md. SelectPlan already publishes PLAN_TOPIC, so this listens rather than
        // introducing a second source of truth.
        this.state = { selectedPlan: null };
    }

    componentDidMount() {
        this.planToken = PubSub.subscribe('PLAN_TOPIC', (msg, data) => {
            if (data && data.action === 'PlanSelected' && data.plan) {
                this.setState({ selectedPlan: data.plan });
            }
        });
    }

    componentWillUnmount() {
        if (this.planToken) PubSub.unsubscribe(this.planToken);
    }

    render() {
        const {
            props: {
                anchorEl,
                appContext, 
                auth,
                classes,
                handleMenu, handleMenuClose, isMenuOpen,
                onSettings, onSignOut, onToggle,
                open,
                username
            }
        } = this;
        const {
            dialog,
            selectedPlan
        } = this.state;
        const { mode } = appContext.state;
        const pathname = window.location.pathname.slice(1).split('/')[0];

        return <div>
            <div className={classes.toolbar} />
            <AppBar position='fixed' className={clsx(classes.appBar, { [classes.appBarShift]: open })}>
                <Toolbar disableGutters={! open}>
                    <IconButton aria-label='Menu' color='inherit' className={classes.menuButton}
                        onClick={onToggle}>
                    <MenuIcon /></IconButton>
                    <Typography variant='h6' color='inherit' className={classes.grow}>
                        {<T.span text={pathname} />}
                    </Typography>
                    {auth && <div>
                        {/* The §10 content-authoring persona. It replaced the Rosetta Agent, which was
                            retired 2026-08-20 — see docs/plans/mcp-server.md §10.7. */}
                        <AIAgent appContext={appContext} persona='expert' title='Ask Apricity'
                            // Accurate about WHEN a write happens 🔒 Richard, 2026-08-21: the previous wording promised
                            // "you will see the diff before anything is written", which is false. Propose-then-apply was
                            // dropped (§10) — saves go straight into the database and logAndDiffChange records the diff
                            // AFTERWARDS, in the Changes view. Promising a review step that does not exist is worse than
                            // promising nothing.
                            greeting={'Ask me about the content in this plan — data types, questions, models and '
                                + 'recommendations. I can create and update records too: saves take effect immediately, and '
                                + 'every change is diffed into the change log so you can review or revert it there.'}
                            context={selectedPlan
                                ? { planId: selectedPlan.planId, planTitle: selectedPlan.title }
                                : undefined} />
                        <SelectPlan hideProtected={mode !== 'advanced'} appContext={appContext} style={
                            {
                                backgroundColor: 'white',
                                margin: '10px', padding: '5px 5px 5px 25px', borderRadius: '10px'
                            }} />
                        <span>{username}</span>
                        <IconButton aria-haspopup aria-owns={isMenuOpen ? 'menu-appbar' : undefined}
                            color='inherit' onClick={handleMenu}
                        ><AccountCircle /></IconButton>
                        <Menu id='menu-appbar' open={isMenuOpen} anchorEl={anchorEl} anchorOrigin={
                            { vertical: 'top', horizontal: 'right' }} transformOrigin={
                                { vertical: 'top', horizontal: 'right' }} onClose={handleMenuClose}
                        >
                            <MenuItem onClick={e => onSettings()}>Settings</MenuItem>
                            <MenuItem onClick={e => onSignOut()}>Logout</MenuItem>
                        </Menu>
                    </div>}
                </Toolbar>
                {dialog}
            </AppBar>
        </div>;
    }
};


const drawerWidth = 300;
const styles = theme => ({
    appBar: {
        transition: theme.transitions.create(['width', 'margin'], {
            easing: '350ms',
            duration: '350ms',
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: '350ms',
            duration: '350ms',
        }),
    },
    toolbar: {
        display: 'flex',
        alignItems: 'left',
        justifyContent: 'flex-start',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    menuButton: {
        marginLeft: 5,
        marginRight: 36,
    },
    grow: {
        flexGrow: 1,
    }
});


export default withStyles(styles, { withTheme: true })(AppHeader);